import { getEventBus } from '@alfa-bank/newclick-core/window-utils';
import { type EventMap } from '@alfa-bank/newclick-types';
import { VoipOptions } from '@alfa-bank/newclick-types/open-side-panel-params/options/voip';

export const useVoip = () => {
    const eventBus = getEventBus();

    const closeVoip = () => {
        eventBus?.emit('CHANGE_VOIP_STATE' as keyof EventMap, {
            open: false,
        });
    };

    const openVoip = (options: VoipOptions) => {
        eventBus?.emit('CHANGE_VOIP_STATE' as keyof EventMap, {
            open: true,
            options,
        });
    };

    return {
        openVoip,
        closeVoip,
    };
};
